import type { IconSvgObject } from './types';

const ChartColumnBigIcon: IconSvgObject = [
  ["path", { d: "M10 17H9C8.44772 17 8 16.5523 8 16L8 10C8 9.44772 8.44772 9 9 9L10 9C10.5523 9 11 9.44772 11 10L11 16C11 16.5523 10.5523 17 10 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 17H16C15.4477 17 15 16.5523 15 16L15 6C15 5.44772 15.4477 5 16 5L17 5C17.5523 5 18 5.44771 18 6L18 16C18 16.5523 17.5523 17 17 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 3V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ChartColumnBigIcon;
